//FIXME: this file is still used before getting to scheduler by ap/path
angular.module('capability-ng-scheduler').factory('SectionTypeBuilder', function SectionTypeBuilder(Interface) {
  const DTD = {
    id: 'key',
    nk: 'string',
    cd: 'string',
    name: 'string',
    term: 'key',
    course: 'key',
    is_required: 'boolean',
    is_active: 'boolean',
    rank: 'integer'
  };
  function SectionTypeDTO(data) {
    Interface.implement(DTD, data, this);

    //we will fallback to cd if name is blank from api
    if (this.name === '' || this.name === null) {
      this.name = this.cd;
    }
  }

  return SectionTypeDTO;
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/builders/suggestions/section_type_builder.es.js